module.exports = __webpack_public_path__ + "static/water_glacier25-8b32aec81d434c94861dffc63871776e.jpg";